jQuery.feature_import("js-purchase_itemlist",
  () => require("./purchasepage-itemlistcontrol.js"),
  mod => mod.feature_js_purchase_itemlist
);